import { useEffect } from 'react';
import { Text, Box } from '@chakra-ui/react';
import Hero from 'components/layouts/Hero';
import Container from 'components/common/Container';
import Popular from 'components/common/SectionsBlog/Popular';
import MetaTagsHandler from 'components/common/MetaTagsHandler';
import { setBlogView as apiSetBlogView } from 'services/blog';
import { useRouter } from 'next/router';
import InfoIcons from 'components/common/InfoIcons';
import BreadCrumb from 'components/common/BreadCrumb';
import RenderSections from 'components/common/RenderSections';
import TitleSingleBlog from 'components/blog/TitleSingleBlog';
import StructuredDataJson from 'components/common/StructuredDataJson';
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import Tracking from 'utils/tracking';

export default function Blog({ title, image, body, created, category, sections, page, metaTags, breadcrumbs }) {
  const router = useRouter();

  function createDescriptionMarkup() {
    return { __html: body };
  }

  useEffect(() => {
    apiSetBlogView(router.locale, page.id);
  }, []);

  useEffect(() => {
    if (page) {
      Tracking.articleView(page.id, title);
    }
  }, [page?.id]);

  const videoHero = sections && sections.find((i) => i.type === 'video' && i.is_hero_banner);
  const { t } = useTranslation('contact');

  return (
    <>
      <Head>
        <title>{t('contactDetails')}</title>
      </Head>
      <div>
        {metaTags && <MetaTagsHandler metaTags={metaTags} />}

        {videoHero && videoHero.is_hero_banner === true ? (
          <Hero
            blog
            title={title}
            image={image}
            created={created}
            categoryName={category?.name}
            data={videoHero?.data}
            video={videoHero.is_hero_banner}
          />
        ) : (
          <TitleSingleBlog title={title} created={created} categoryName={category?.name} />
        )}

        <>
          <StructuredDataJson
            type={'BlogPosting'}
            title={title}
            created={created}
            image={image}
            categoryName={category?.name}
            blog={true}
          />
          <Container>
            <Box ml={{ base: '0', lg: '25px' }} pos={{ base: 'relative', lg: 'absolute' }} top="10px">
              <BreadCrumb breadcrumbs={breadcrumbs} />
            </Box>
            <Text
              className={'blog_body'}
              as={'div'}
              p={{
                base: '20px 0 30px 0',
                md: '60px 0 30px 0',
                lg: '120px 90px 30px 90px',
                xl: '120px 120px 30px 120px',
              }}
              dangerouslySetInnerHTML={createDescriptionMarkup()}
            />
          </Container>

          <RenderSections sections={sections} />

          <Popular />

          {sections &&
            sections?.map(({ type, block }, index) => {
              switch (type) {
                case 'custom_block':
                  return <InfoIcons block={block} key={`InfoIcons-${index}`} />;
              }
            })}
        </>
      </div>
    </>
  );
}
